import axios from "axios"
import { initDiagnostics, recordApiFailure } from "./diagnostics"
import { getServerUrl } from "./UrlHelper"
import { getTenant } from "./tenantResolver"
import { getAuthToken, clearAuthToken } from "./tenantStorage"
import {
  TENANT_MISMATCH_MESSAGE,
  TENANT_MISMATCH_EVENT,
  SESSION_EXPIRED_CODE,
  SESSION_EXPIRED_EVENT,
} from "./authEvents"

initDiagnostics()

/** Len nas backend -- hlavicky (a token!) nesmu odist na cudzie hosty. */
function jeNasBackend(url) {
  const u = String(url || "")
  if (u.startsWith("/")) return !u.startsWith("//")
  return u.startsWith(getServerUrl() + "/")
}

function nastavHlavicku(config, nazov, hodnota) {
  if (typeof config.headers?.set === "function") config.headers.set(nazov, hodnota)
  else config.headers = { ...(config.headers || {}), [nazov]: hodnota }
}

function hodnotaHlavicky(config, nazov) {
  const h = config?.headers
  if (!h) return null
  if (typeof h.get === "function") return h.get(nazov) ?? null
  const k = Object.keys(h).find((x) => x.toLowerCase() === nazov.toLowerCase())
  return k ? h[k] : null
}

/**
 * Odisla poziadavka s tokenom, ktory je PRAVE ulozeny? Inak sa vyprsanie
 * neriesi: explicitne zadany token (platformova sprava) nie je nas, a ked
 * paralelne poziadavky vratia 401 naraz, token zahodi a udalost posle len prva.
 */
function poslalaUlozenyToken(config) {
  const token = getAuthToken()
  return Boolean(token) && hodnotaHlavicky(config, "Authorization") === `Bearer ${token}`
}

function maHlavicku(config, nazov) {
  if (!config.headers) return false
  if (typeof config.headers.has === "function") return config.headers.has(nazov)
  return Object.keys(config.headers).some((k) => k.toLowerCase() === nazov.toLowerCase())
}

// REQUEST interceptor -- od prechodu na path-based multi-tenancy (F4).
//
// Povodne sa token posielal rucne na ~41 miestach a request interceptor bol
// zamerne vynechany. Na jednej domene by vsak kazde z tych miest potrebovalo
// token konkretnej prevadzky -- a jedno zabudnute by potichu poslalo token
// cudzej firmy (zle data, nie pad). Preto je token LEN tu:
//
//   X-Company-Slug   prevadzka z cesty (rozvozy.sk/veteran); pri vlastnej
//                    domene sa neposiela -- backend ju pozna podla Origin
//   Authorization    token AKTUALNEJ prevadzky z tenantStorage; explicitne
//                    zadany sa neprepisuje (platformova sprava pri act-as)
axios.interceptors.request.use((config) => {
  if (!jeNasBackend(config.url)) return config
  const tenant = getTenant()
  if (tenant.mode === "path" && tenant.slug) {
    nastavHlavicku(config, "X-Company-Slug", tenant.slug)
  }
  const token = getAuthToken()
  if (token && !maHlavicku(config, "Authorization")) {
    nastavHlavicku(config, "Authorization", `Bearer ${token}`)
  }
  return config
})

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Celé v try/catch: interceptor nesmie za žiadnych okolností zmeniť
    // správanie volajúceho kódu.
    try {
      recordApiFailure({
        method: error?.config?.method,
        url: error?.config?.url || "",
        status: error?.response?.status,
        // Len správa zo servera -- nikdy celé response.data ani request body.
        message: error?.response?.data?.message || error?.message,
      })

      // Token inej prevádzky: zahodiť ho a dať vedieť AuthContextu, ktorý
      // používateľa ticho odhlási (bez presmerovania -- riziko slučky).
      if (error?.response?.status === 403 && error?.response?.data?.message === TENANT_MISMATCH_MESSAGE) {
        clearAuthToken()
        window.dispatchEvent(new Event(TENANT_MISMATCH_EVENT))
      }

      // Vyprsany alebo neplatny token: doteraz ostal ulozeny, UI tvrdilo
      // "prihlaseny", zakaznik videl verejne ceny a pri odoslani dostal
      // anglicke "Invalid token". Teraz ho zahodime a AuthContext s Headerom
      // pouzivatela odhlasia a ponuknu prihlasenie.
      if (
        error?.response?.status === 401 &&
        error?.response?.data?.kod === SESSION_EXPIRED_CODE &&
        poslalaUlozenyToken(error.config)
      ) {
        clearAuthToken()
        window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT))
      }
    } catch {
      /* ticho */
    }
    // KRITICKÉ: chyba musí ísť ďalej nezmenená, inak sa rozbijú všetky
    // existujúce .catch() vetvy (napr. AuthContext.checkAuthStatus).
    return Promise.reject(error)
  },
)
